import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'wilson-header-renderer',
  template: `
    <div class="d-flex flex-column justify-content-center">
      <span class="text-dark text-truncate lh-lg">
        {{ cellValue ? cellValue : '---' }}
      </span>
      <span class="list-header lh-1">
        {{ headerValue | translate }}
      </span>
    </div>
  `,
  standalone: false,
})
export class HeaderRendererComponent implements AgRendererComponent {
  public cellValue!: string;
  public headerValue!: string;

  agInit(params: ICellRendererParams): void {
    this.cellValue = this.getValueToDisplay(params);
    this.headerValue = params.colDef.headerName;
  }

  refresh(params: ICellRendererParams) {
    this.cellValue = this.getValueToDisplay(params);
    this.headerValue = params.colDef.headerName;
    return true;
  }

  getValueToDisplay(params: ICellRendererParams) {
    return params.valueFormatted ? params.valueFormatted : params.value;
  }
}
